import CookiesU from "universal-cookie";
const cookies = new CookiesU();

const Globales = {
  Url:
    process.env.NODE_ENV === "production"
      ? "https://api.fabricanook.com/"
      : //'http://3.235.201.128:5001/'
        //  'http://34.238.174.80:5001/'
        "http://localhost:5001/",

  token: "Bearer " + cookies.get("token") /*.replace(/['"]+/g, '')*/,
  usuario: localStorage.getItem("Usuario"),
};
export default Globales;
